<template>
  <div>
    <wc-data-box
      title='Status'
    >
      <template v-slot:toolbarButtons>
        <status-chip :status='invoice.status' label></status-chip>
      </template>
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='labelClass'>Total</td>
            <td :class='valueClass'>{{ invoice.original_amount | decMoney }}</td>
          </tr>
          <tr>
            <td :class='labelClass'>Payments</td>
            <td class='text-right'>{{ invoice.original_amount - invoice.amount_os | decMoney }}</td>
          </tr>
          <tr>
            <td :class='labelClass'>Balance</td>
            <td :class='invoice.amount_os > 0 ? redClass : greenClass'>{{ invoice.amount_os | decMoney }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  </div>
</template>

<script>
import StatusChip from '@/modules/accounting/components/invoice/StatusChip';

export default {
  name: 'invoice-balance',
  props: {
    invoice: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    labelClass: 'grey--text text-uppercase',
    valueClass: 'font-weight-bold text-right',
    redClass: 'font-weight-bold text-right error--text',
    greenClass: 'font-weight-bold text-right success--text',
    payments: [],
    status: ''
  }),
  components: {
    'status-chip': StatusChip
  }
}
</script>
